import { footerLinks, siteMeta } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-8xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                黑
              </span>
              <strong className="font-heading text-lg font-bold text-background-50">
                {siteMeta.name}
              </strong>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              {siteMeta.slogan}
            </p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-secondary-300">
              内容以行业机制与公开信息为基础，坚持对事不对人。如发现表述有误，欢迎通过更正渠道联系我们。
            </p>
          </div>

          <nav className="md:col-span-4" aria-label="页脚导航">
            <h2 className="font-heading text-sm font-semibold text-background-50">站内导航</h2>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-3">
            <h2 className="font-heading text-sm font-semibold text-background-50">联系我们</h2>
            <ul className="mt-4 space-y-3 text-sm text-secondary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-send-line text-accent-400"></i>
                <a
                  href={`mailto:${siteMeta.email}`}
                  rel="nofollow"
                  className="break-all transition-colors hover:text-accent-300"
                >
                  {siteMeta.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                工作日 10:00 / 18:00 更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-calendar-line text-accent-400"></i>
                内容最近更新：{siteMeta.buildTime}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteMeta.name}. 保留所有权利。</p>
          <p className="leading-relaxed">
            本站内容仅为行业观察与信息整理，不构成对任何个人的指控或评价。
          </p>
        </div>
      </div>
    </footer>
  );
}